const topics = [
  { name: '科幻大片', count: '12.6万讨论', hot: true },
  { name: '悬疑推理', count: '9.8万讨论', hot: true },
  { name: '国产影视', count: '8.4万讨论', hot: true },
  { name: '动作枪战', count: '7.2万讨论', hot: false },
  { name: '日韩剧场', count: '6.9万讨论', hot: false },
  { name: '欧美新片', count: '6.5万讨论', hot: false },
  { name: '喜剧搞笑', count: '5.8万讨论', hot: false },
  { name: '恐怖惊悚', count: '5.3万讨论', hot: false },
  { name: '动漫番剧', count: '4.9万讨论', hot: false },
  { name: '纪录片', count: '4.2万讨论', hot: false },
  { name: '经典老片', count: '3.7万讨论', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-sm font-medium mb-4 whitespace-nowrap">
            话题中心
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            大家都在讨论的影视话题，加入交流发现更多好片
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <div
              key={topic.name}
              className={`group px-5 py-3 rounded-full border cursor-pointer transition-all duration-200 flex items-center gap-2 ${
                topic.hot
                  ? 'bg-accent-50 border-accent-200 hover:bg-accent-100'
                  : 'bg-background-50 border-background-200/70 hover:bg-background-200/60'
              }`}
            >
              <span className={`text-sm font-semibold whitespace-nowrap ${
                topic.hot ? 'text-accent-700' : 'text-foreground-700'
              }`}>
                {topic.name}
              </span>
              <span className={`text-xs whitespace-nowrap ${
                topic.hot ? 'text-accent-500' : 'text-foreground-400'
              }`}>
                {topic.count}
              </span>
              {topic.hot && (
                <i className="ri-fire-line text-accent-500 text-sm"></i>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}